import config from './config';

// Returns { thumbnail, medium, large } URLs for a product or order item
export function getImageUrls(prod, fallbackUrl) {
  const imageUrl = prod && (prod.ImageUrl || prod.imageUrl || prod.image || prod.img);
  const fallback = fallbackUrl || 'https://elora.site/logo-storesye.png';

  if (!imageUrl) return { thumbnail: fallback, medium: fallback, large: fallback };

  // Multi-size object
  if (typeof imageUrl === 'object' && imageUrl.thumbnail) {
    return {
      thumbnail: imageUrl.thumbnail.startsWith('http')
        ? imageUrl.thumbnail
        : `${config.SITE_BASE_URL}${imageUrl.thumbnail}`,
      medium: imageUrl.medium.startsWith('http')
        ? imageUrl.medium
        : `${config.SITE_BASE_URL}${imageUrl.medium}`,
      large: imageUrl.large.startsWith('http')
        ? imageUrl.large
        : `${config.SITE_BASE_URL}${imageUrl.large}`
    };
  }

  // Legacy string
  if (typeof imageUrl === 'string') {
    let fullUrl = fallback;
    if (imageUrl.startsWith('http') || imageUrl.startsWith('data:image')) {
      fullUrl = imageUrl;
    } else if (imageUrl.startsWith('/images/')) {
      fullUrl = `${config.SITE_BASE_URL}${imageUrl}`;
    } else {
      fullUrl = imageUrl;
    }
    return { thumbnail: fullUrl, medium: fullUrl, large: fullUrl };
  }

  return { thumbnail: fallback, medium: fallback, large: fallback };
}
